import _Object$assign from 'babel-runtime/core-js/object/assign';

import { PermissionKey, GrantType, PlanNormal } from '@/common/permission';
import AuthorizePlanPlayable from './authorize-plan-playable.vue';
import { ChangeKeys } from '../config';

export default {
  components: { AuthorizePlanPlayable: AuthorizePlanPlayable },
  props: {
    formValue: {
      type: Object,
      required: true
    },
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    action: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      options: [],
      resetDayOptions: [{
        label: '30天，按月清零重置套餐',
        value: 30
      }, {
        label: '365天，按年清零重置套餐。若订阅周期不足一年，到期会自动取消授权不需要重置',
        value: 365
      }],
      GrantType: GrantType
    };
  },

  computed: {
    showPlayableAttrs: function showPlayableAttrs() {
      return !!this.options.find(function (t) {
        return [PermissionKey.gm, PermissionKey.ps].includes(t.value);
      });
    },
    mtg_charge: function mtg_charge() {
      if (this.formValue.mtg_charge === 1) {
        return '是';
      } else if (this.formValue.mtg_charge === 2) {
        return '否';
      }
      return '-';
    },
    showOnline: function showOnline() {
      return this.formValue.change_keys.includes(ChangeKeys.Online);
    },
    showDownloadPush: function showDownloadPush() {
      return this.formValue.change_keys.includes(ChangeKeys.DownloadPush);
    },
    showVoiceClone: function showVoiceClone() {
      return this.formValue.change_keys.includes(ChangeKeys.VoiceClone);
    },
    showVideoCredits: function showVideoCredits() {
      return this.formValue.change_keys.includes(ChangeKeys.VideoCredits);
    },

    // 充值套餐下显示单价
    showUnitPrice: function showUnitPrice() {
      return this.formValue.plan_id === PlanNormal.planCPM || this.formValue.plan_id === PlanNormal.planREV;
    },

    // 企业套餐下自由定制功能权限及额度
    showPermissions: function showPermissions() {
      return this.formValue.plan_id !== PlanNormal.planEnterprise;
    },
    unit_price_text: function unit_price_text() {
      return this.formValue.plan_id === PlanNormal.planCPM ? 'cpm套餐的单价范围$0.1-$20,  默认$0.5' : 'rev套餐的单价范围是0.1%-20%, 默认3%';
    },
    max_service_fee_text: function max_service_fee_text() {
      return this.formValue.plan_id === PlanNormal.planCPM ? '默认800，不得小于$200' : '默认1500，不得小于$200';
    }
  },
  watch: {
    'formValue.plan_id': function formValuePlan_id(val) {
      this.getPermissionsOptions();

      if (val === PlanNormal.planCPM) {
        _Object$assign(this.formValue, {
          unit_price: 0.5,
          max_service_fee: 800,
          is_set_price_ceiling: true
        });
      } else if (val === PlanNormal.planREV) {
        _Object$assign(this.formValue, {
          unit_price: 3,
          max_service_fee: 1500,
          is_set_price_ceiling: false
        });
      }
    }
  },
  methods: {
    getPermissionsOptions: function getPermissionsOptions() {
      var _this = this;

      var data = [{ value: PermissionKey.gm, label: '可玩换肤编辑' }, { value: PermissionKey.ps, label: '可玩自由编辑' }, { value: PermissionKey.ve, label: '视频普通制作' }, { value: PermissionKey.vrec, label: '录屏工具' }, { value: PermissionKey.veBatch, label: '视频批量制作' }, { value: PermissionKey.aigc, label: 'AI视频' }, { value: PermissionKey.veTpl, label: '视频模版' }, { value: PermissionKey.ai, label: 'ai服务' }, { value: PermissionKey.insights, label: '创意洞察' }];
      console.log('permissions', this.formValue.permissions);
      this.options = data.filter(function (item) {
        return _this.formValue.permissions.includes(item.value);
      });
    },
    getLimitValue: function getLimitValue(value) {
      return value === -1 ? '无限制' : value;
    },
    checkDisabled: function checkDisabled() {
      return this.action === 'update' || this.formValue.grant_type !== GrantType.Normal;
    }
  },
  created: function created() {
    this.getPermissionsOptions();
  }
};